import React, { useState, useRef } from 'react'
import styled, { keyframes } from 'styled-components'
import { fadeIn } from 'react-animations'

interface Props {
    title: String
    children: any[]
}

export default function DropDownIcon({ title, children = [] }: Props) {
    const wrapperRef = useRef(null)
    const [dropDown, setDropDown] = useState(false)

    // useEffect(() => {
    //     document.addEventListener('click', handleClickOutside)
    //     // document.addEventListener("mousedown", hadleClickOutside2)

    //     // returned function will be called on component unmount
    //     return () => {
    //         document.removeEventListener('click', handleClickOutside)
    //         // document.removeEventListener('mousemove', hadleClickOutside2)
    //     }
    // }, [])

    setTimeout(() => {
        if (dropDown) {
            window.addEventListener('click', handleClickOutside)
        } else {
            window.removeEventListener('click', handleClickOutside)
        }
    }, 0)

    const handleButtonClick = () => {
        setDropDown(!dropDown)
    }

    const handleClickOutside = event => {
        if (wrapperRef.current && !wrapperRef.current.contains(event.target)) {
            setDropDown(false)
        }
    }

    return (
        <div ref={wrapperRef}>
            <Container>
                <Icon
                    className="fas fa-ellipsis-v"
                    onClick={handleButtonClick}
                    data-cy={dropDown ? 'dropDownIconOpen' : 'dropDownIconClose'}
                />

                <DropDownContainer
                    style={{
                        display: !dropDown ? 'none' : 'block'
                    }}
                >
                    <Icon
                        className="fas fa-ellipsis-v"
                        onClick={handleButtonClick}
                        style={{
                            position: 'absolute',
                            right: 4,
                            top: 18,
                        }}
                    />
                    <label>{title}</label>
                    <ul>{children}</ul>
                </DropDownContainer>
            </Container>
        </div>
    )
}

const animation = keyframes`${fadeIn}`
// const animation = keyframes`${fadeOutLeft}`
const animation2 = keyframes`
  from {
    height: 0px;
    /* width: 0px; */
  }
  to {
    height: 263px;
    /* width: 250px; */
  }
`
const Container = styled.div`
    height: 100%;
    position: relative;
    font-family: 'Source Sans Pro', sans-serif; 
`
const Icon = styled.i`
    font-family: Font Awesome 5 Pro;
    font-style: normal;
    font-weight: normal;
    font-size: 14px;
    /* line-height: 40px; */
    color: #37a3ef;
    display: flex;
    align-items: center;
    justify-content: center;
    width: 20px;
    cursor: pointer;
`

const DropDownContainer = styled.div`
    animation: 0.4s ${animation};
    /* animation-direction: reverse; */
    position: absolute;
    top: -19px;
    left: -225px;
    font-family: 'Source Sans Pro', sans-serif; 
    /* left: -100px; */
    width: 250px;
    z-index: 99;
    padding: 1.5rem 1rem;
    border: 1px solid rgba(0, 0, 0, 0.04);
    box-shadow: 0 16px 24px 2px rgba(0, 0, 0, 0.14);
    background-color: var(--gray-0);
    border: 1px solid #c8ccd4;

    label {

        font-style: normal;
        font-weight: 600;
        font-size: 12px; 
        line-height: 16px;
        font-family: 'Source Sans Pro', sans-serif; 
        padding: 8px 8px;
        text-transform: uppercase;
        color: #364159;
    }

    ul {
        list-style: none;
        padding: 0;
        font-family: 'Source Sans Pro', sans-serif; 
        margin: 0;
    }

    li {
        padding: 0px 7px;
        font-family: 'Source Sans Pro', sans-serif; 
        &:hover {
            background-color: var(--gray-200);
            cursor: pointer;
        }
    }
`
